import { ChevronDown } from "lucide-react";
import { useState } from "react";
import GeneralApplicationTable from "./components/GeneralApplicationTable";
import InsightAndRules from "./components/InsightAndRules";

const tabs = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Priority",
    value: "priority",
  },
  {
    label: "In progress",
    value: "in-progress",
  },
  {
    label: "Below threshold",
    value: "below-threshold",
  },
  {
    label: "Declined",
    value: "declined",
  },
];

const ApplicationManagement = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [isInsightAndRulesExpanded, setIsInsightAndRulesExpanded] =
    useState(false);

  return (
    <section className="flex flex-col flex-1 min-h-0 bg-white rounded-md border p-5">
      <div className="flex items-center justify-between gap-5">
        {/* Tabs container */}
        <div className="flex items-center border-b justify-between flex-1 pt-4">
          {tabs?.map((tab) => {
            const isActive = tab?.value == activeTab;
            return (
              <button
                key={tab?.value}
                onClick={() => setActiveTab(tab?.value)}
                className={`text-xs font-semibold pb-5 px-4 border-b-2 ${isActive ? "border-b-slate-600 text-charcoal" : "border-b-transparent text-content-muted hover:text-charcoal"}`}
              >
                {tab?.label}
              </button>
            );
          })}
        </div>
        <div className="h-12 w-px bg-gray-200" />
        {/* Insight and rules */}
        <button
          onClick={() => setIsInsightAndRulesExpanded((prev) => !prev)}
          className="flex items-center p-3 rounded-md border text-xs font-semibold gap-5 text-content-muted group hover:bg-slate-50 hover:border-light-grey"
        >
          Insight and rules
          <div className="rounded-full h-6 w-6 border flex items-center justify-center group-hover:border-light-grey">
            <ChevronDown
              size={14}
              className={`transition-transform duration-200 ease-out ${
                isInsightAndRulesExpanded ? "rotate-180" : "rotate-0"
              }`}
            />
          </div>
        </button>
      </div>

      {isInsightAndRulesExpanded ? (
        <InsightAndRules />
      ) : (
        <GeneralApplicationTable tab={activeTab} />
      )}
    </section>
  );
};

export default ApplicationManagement;
